import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1.2, ease: "easeOut" } },
};

// Animate on mount with staggered delay. Reliable across scroll-snap containers.
export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      variants={fadeUp}
      custom={delay}
      initial="hidden"
      animate="show"
      className={className}
    >
      {children}
    </Comp>
  );
};

export const Overline = ({ children, className = "", testId }) => (
  <span
    data-testid={testId}
    className={`font-sans text-[0.7rem] uppercase tracking-luxe text-[var(--ais-gold)] ${className}`}
  >
    {children}
  </span>
);
